import { Injectable } from "@angular/core";
import {
  HttpResponse,
  HttpInterceptor,
  HttpRequest,
  HttpHandler,
  HttpEvent,
} from "@angular/common/http";
import { Observable, throwError } from "rxjs";
import { tap, catchError } from "rxjs/operators";
import { Router, ActivatedRoute } from "@angular/router";
import { NgxSpinnerService } from "ngx-spinner";
import Swal from "sweetalert2";
import * as SecureLS from "secure-ls";
@Injectable()
export class HttpTokenInterceptor implements HttpInterceptor {
  private ls = new SecureLS({ encodingType: "aes" });
  isLoginType: boolean;
  constructor(
    private routes: Router,
    private spinner: NgxSpinnerService,
    private route: ActivatedRoute
  ) {}

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    let authReq;
    const token: string = this.ls.get("token");
    let newHeaders = request.headers;
    if (token) {
      if (
        this.route.queryParams["value"].loginType == "impersonate" &&
        this.ls.get("impersonate_role") &&
        this.ls.get("impersonate_user_id")
      ) {
        let impersonat_token = this.ls.get("impersonate_token");
        newHeaders = newHeaders.append(
          "Authorization",
          "Bearer " + impersonat_token
        );
        newHeaders = newHeaders.append("logintype", "impersonate");
      } else {
        newHeaders = newHeaders.append("Authorization", "Bearer " + token);
      }

      if (
        this.route.queryParams["value"].loginType == "impersonate" &&
        this.ls.get("impersonate_role") &&
        this.ls.get("impersonate_user_id")
      ) {
        let urlToProced = request.url;
        let bodyToProced = request.body;

        if (
          request.method.toLowerCase() === "post" ||
          request.method.toLowerCase() === "put"
        ) {
          if (bodyToProced.user_id) {
            bodyToProced.user_id = this.ls.get("impersonate_user_id");
          }

          if (bodyToProced.role_id) {
            bodyToProced.role_id = this.ls.get("impersonate_role");
          }
        }

        if (
          request.method.toLowerCase() === "get" ||
          request.method.toLowerCase() === "delete"
        ) {
          let setUrl = request.url.split("?");
          let urlToApi = setUrl[0];

          if (setUrl.length > 1) {
            let pramesImp = new URLSearchParams(setUrl[1]);
            pramesImp.set("user_id", this.ls.get("impersonate_user_id"));
            pramesImp.set("role_id", this.ls.get("impersonate_role"));
            urlToProced = urlToApi + "?" + pramesImp.toString();
          }
        }
        authReq = request.clone({
          url: urlToProced,
          headers: newHeaders,
          body: bodyToProced,
        });
      } else {
        authReq = request.clone({ headers: newHeaders });
      }
    } else {
      authReq = request.clone({ headers: newHeaders });
    }
    return next.handle(authReq).pipe(
      tap((event) => {
        if (event instanceof HttpResponse) {
          if (event.body["status"] === 400) {
            Swal.fire("Error!", event.body["message"], "error");
          }
          if (event.body["status"] === 500) {
            Swal.fire("Error!", event.body["message"], "error");
          }
          if (event.body["status"] === 404) {
            Swal.fire("Error!", event.body["message"], "error");
          }
          if (event.body["status"] === 403) {
            Swal.fire("Error!", event.body["message"], "error");
          }
        }
      }),
      catchError((error) => {
        if (error.status == 401) {
          this.spinner.hide();
          if (error.url.indexOf("/list/notification") == -1) {
            Swal.fire(
              "Information!",
              "Your not authorized to visit this page or session expired",
              "error"
            );
          }

          this.routes.navigate(["/"]);
        }
        return throwError(error);
      })
    );
  }
}
